import LaborDashboard from './LaborDashboard';

export default LaborDashboard;
